import { render, staticRenderFns } from "./treatment_history.vue?vue&type=template&id=a80b1da2"
import script from "./treatment_history.vue?vue&type=script&lang=js"
export * from "./treatment_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports